/**
 * Login response codes
 * @module services/auth/login-codes
 */

/**
 * The username or password is not recognized
 */
export const LOGIN_CODE_UNRECOGNIZED_USERNAME_PASSWORD = 'unrecognizedUsernameOrPassword'

/**
 * The authentication is not valid
 */
export const LOGIN_CODE_INVALID_TOKEN = 'invalidToken'

/**
 * The user is not active or blocked
 */
export const LOGIN_CODE_BLOCKED_USER = 'blockedUser'
